module.exports = __webpack_public_path__ + "img/screenfull-Dsuccess.b4ef2214.png";